import {objectFromEntries} from '@benchling/js-utils';
import {useMemo} from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

interface SampleTestPlanWithPublishedProcedureFlowchartVersion {
  procedureId: string;
  publishedProcedureFlowchartVersionId: string;
}

export function usePublishedProcedureFlowchartVersionIdsByProcedureId(
  sampleTestPlans: Array<{
    procedureId: string;
    publishedProcedureFlowchartVersionId: string | null;
  }>
): Record<string, string> {
  return useMemo(() => {
    if (!BenchlingConfig.PROCEDURES_ENABLE_PUBLISHING) {
      return {};
    }

    return objectFromEntries(
      sampleTestPlans
        .filter(
          (sampleTestPlan): sampleTestPlan is SampleTestPlanWithPublishedProcedureFlowchartVersion =>
            sampleTestPlan.publishedProcedureFlowchartVersionId != null
        )
        .map((sampleTestPlan) => [
          sampleTestPlan.procedureId,
          sampleTestPlan.publishedProcedureFlowchartVersionId,
        ])
    );
  }, [sampleTestPlans]);
}

/**
 * Extracts the published procedure flowchart version ID from a procedure object.
 */
export function getPublishedProcedureFlowchartVersionId(procedure: {
  procedureFlowchart?: null | {
    __typename?: string;
    publishedFlowchartVersion?: null | {
      __typename?: string;
      id?: string;
    };
  };
}): string | null {
  return procedure.procedureFlowchart != null &&
    !isInaccessible(procedure.procedureFlowchart) &&
    procedure.procedureFlowchart.publishedFlowchartVersion != null &&
    !isInaccessible(procedure.procedureFlowchart.publishedFlowchartVersion) &&
    procedure.procedureFlowchart.publishedFlowchartVersion.id != null
    ? procedure.procedureFlowchart.publishedFlowchartVersion.id
    : null;
}
